<template>
    <div class="filter__block">
        <div class="filter__block_trigger">{{ get_translation_constant('text_filter_results') }}</div>
        <div class="filter__block_cotent">

            <div class="row">
                <div class="col-12 col-md-6 col-lg-12">
                    <div class="form__col">
                        <input class="form__control form__search" v-model="search" type="text"
                               :placeholder="get_translation_constant('text_search_by_name')">
                    </div>
                </div>
                <div class="col-12 col-md-6 col-lg-12">
                    <div class="form__col">
                        <multiselect v-model="sortBy"
                                     :multiple="false"
                                     :placeholder="''"
                                     :options="sortOptions"
                                     label="name"
                                     selectLabel=""
                                     deselectLabel=""
                                     :optionHeight="48"
                                     :showPointer="true"
                        >
                            <template></template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="filter__block_group">
                <h4 class="h_text">{{ get_translation_constant('text_categories') }}</h4>
                <div class="checkbox__custom" v-for="(category, index) in categories">
                    <input :id="'category'+index" v-model="marketCategory[index].checked" type="checkbox"
                           name="marketCategory">
                    <label :for="'category'+index">{{ categoryName(category) }}</label>
                </div>
            </div>
            <div class="filter__block_group">
                <h4 class="h_text">{{ get_translation_constant('text_countries') }}</h4>
                <div class="checkbox__custom" v-for="(country, index) in countries">
                    <input :id="'country'+index" v-model="marketCountry[index].checked" type="checkbox"
                           name="marketCountry">
                    <label :for="'country'+index">{{ countryName(country) }}</label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FilterShops",
    props: {
        translations: {
            type: [Object, Array]
        },
        categories: {
            type: [Object, Array]
        },
        countries: {
            type: [Object, Array]
        },
        lng: {
            type: [String]
        },
        mainlng: {
            type: [String]
        },
    },
    data() {
        return {
            sortOptions: [
                {
                    id: 1,
                    search: 'name',
                    name: this.get_translation_constant('text_search_by_name')

                },
                {
                    id: 2,
                    search: 'is_popular',
                    name: this.get_translation_constant('text_popular')

                },
                {
                    id: 3,
                    search: 'is_sale',
                    name: this.get_translation_constant('text_sales')
                },
            ],
            sortBy: {
                id: 1,
                search: 'name',
                name: 'name'
            },
            marketCategory: [],
            marketCountry: [],
            search: '',
            timer: null,
            searchChange: false
        }

    },
    methods: {
        categoryName(category) {
            return category.title
        },
        countryName(country) {
            return country.title
        },
        get_translation_constant(key) {
            return this.translations.filter((item) => {
                return item.key === key
            })[0]['value'][this.lng]
        },
        searchTimeOut() {
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
                this.searchChange = false;
            }
            this.searchChange = true;
            this.timer = setTimeout(() => {
                this.$emit('childToParent', this.$data)
            }, 1000);
        },
    },
    computed: {},
    mounted() {

    },
    created() {
        this.marketCategory = this.categories
        this.marketCountry = this.countries
    },
    watch: {
        'marketCategory': {
            handler(val) {
                this.$emit('childToParent', this.$data)
            },
            deep: true
        },
        'marketCountry': {
            handler(val) {
                this.$emit('childToParent', this.$data)
            },
            deep: true
        },
        'sortBy': {
            handler(val) {
                this.$emit('childToParent', this.$data)
            },
            deep: true
        },
        'search': {
            handler(val) {
                this.searchTimeOut()
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>
